import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import ProtectedRoute from "@/components/shared/ProtectedRoute";

import PublicLayout from "@/components/layout/PublicLayout";
import Home from "@/pages/public/Home";
import TentangKami from "@/pages/public/TentangKami";
import ProgramList from "@/pages/public/ProgramList";
import ProgramDetail from "@/pages/public/ProgramDetail";
import Pembimbing from "@/pages/public/Pembimbing";
import Manasik from "@/pages/public/Manasik";
import Galeri from "@/pages/public/Galeri";
import Artikel from "@/pages/public/Artikel";
import ArtikelDetail from "@/pages/public/ArtikelDetail";
import FAQPage from "@/pages/public/FAQPage";
import Kontak from "@/pages/public/Kontak";

import Login from "@/pages/auth/Login";
import Register from "@/pages/auth/Register";
import ForgotPassword from "@/pages/auth/ForgotPassword";

import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminJamaah from "@/pages/admin/AdminJamaah";
import AdminPendaftaran from "@/pages/admin/AdminPendaftaran";
import AdminProgram from "@/pages/admin/AdminProgram";
import AdminManasik from "@/pages/admin/AdminManasik";
import AdminPembimbing from "@/pages/admin/AdminPembimbing";
import AdminDokumen from "@/pages/admin/AdminDokumen";
import AdminPembayaran from "@/pages/admin/AdminPembayaran";
import AdminArtikel from "@/pages/admin/AdminArtikel";
import AdminGaleri from "@/pages/admin/AdminGaleri";
import AdminTestimoni from "@/pages/admin/AdminTestimoni";
import AdminFAQ from "@/pages/admin/AdminFAQ";
import AdminPengumuman from "@/pages/admin/AdminPengumuman";
import AdminPengguna from "@/pages/admin/AdminPengguna";
import AdminAuditLog from "@/pages/admin/AdminAuditLog";
import AdminPengaturan from "@/pages/admin/AdminPengaturan";
import AdminRekening from "@/pages/admin/AdminRekening";
import AdminAffiliate from "@/pages/admin/AdminAffiliate";

import JamaahLayout from "@/pages/jamaah/JamaahLayout";
import JamaahDashboard from "@/pages/jamaah/JamaahDashboard";
import JamaahProfil from "@/pages/jamaah/JamaahProfil";
import JamaahProgram from "@/pages/jamaah/JamaahProgram";
import JamaahManasik from "@/pages/jamaah/JamaahManasik";
import JamaahDokumen from "@/pages/jamaah/JamaahDokumen";
import JamaahPembayaran from "@/pages/jamaah/JamaahPembayaran";
import JamaahMateri from "@/pages/jamaah/JamaahMateri";
import JamaahPengumuman from "@/pages/jamaah/JamaahPengumuman";
import JamaahPembimbing from "@/pages/jamaah/JamaahPembimbing";

import GuideLayout from "@/pages/guide/GuideLayout";
import GuideDashboard from "@/pages/guide/GuideDashboard";
import GuideJamaah from "@/pages/guide/GuideJamaah";
import GuideManasik from "@/pages/guide/GuideManasik";

import AgentLayout from "@/pages/agent/AgentLayout";
import AgentDashboard from "@/pages/agent/AgentDashboard";
import AgentJamaah from "@/pages/agent/AgentJamaah";
import AgentKomisi from "@/pages/agent/AgentKomisi";

const ADMIN_ROLES = ["super_admin", "admin", "operator"];

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <SiteProvider>
          <BrowserRouter>
            <Routes>
              <Route element={<PublicLayout />}>
                <Route index element={<Home />} />
                <Route path="/tentang-kami" element={<TentangKami />} />
                <Route path="/program" element={<ProgramList />} />
                <Route path="/program/haji" element={<ProgramList />} />
                <Route path="/program/umrah" element={<ProgramList />} />
                <Route path="/program/:slug" element={<ProgramDetail />} />
                <Route path="/pembimbing" element={<Pembimbing />} />
                <Route path="/manasik" element={<Manasik />} />
                <Route path="/galeri" element={<Galeri />} />
                <Route path="/artikel" element={<Artikel />} />
                <Route path="/artikel/:slug" element={<ArtikelDetail />} />
                <Route path="/faq" element={<FAQPage />} />
                <Route path="/kontak" element={<Kontak />} />
              </Route>

              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />

              <Route path="/admin" element={<ProtectedRoute roles={ADMIN_ROLES}><AdminLayout /></ProtectedRoute>}>
                <Route index element={<AdminDashboard />} />
                <Route path="jamaah" element={<AdminJamaah />} />
                <Route path="pendaftaran" element={<AdminPendaftaran />} />
                <Route path="program" element={<AdminProgram />} />
                <Route path="manasik" element={<AdminManasik />} />
                <Route path="pembimbing" element={<AdminPembimbing />} />
                <Route path="dokumen" element={<AdminDokumen />} />
                <Route path="pembayaran" element={<AdminPembayaran />} />
                <Route path="artikel" element={<AdminArtikel />} />
                <Route path="galeri" element={<AdminGaleri />} />
                <Route path="testimoni" element={<AdminTestimoni />} />
                <Route path="faq" element={<AdminFAQ />} />
                <Route path="pengumuman" element={<AdminPengumuman />} />
                <Route path="pengguna" element={<AdminPengguna />} />
                <Route path="audit-log" element={<AdminAuditLog />} />
                <Route path="pengaturan" element={<AdminPengaturan />} />
                <Route path="rekening" element={<AdminRekening />} />
                <Route path="affiliate" element={<AdminAffiliate />} />
              </Route>

              <Route path="/jamaah" element={<ProtectedRoute roles={["jamaah"]}><JamaahLayout /></ProtectedRoute>}>
                <Route index element={<JamaahDashboard />} />
                <Route path="profil" element={<JamaahProfil />} />
                <Route path="program" element={<JamaahProgram />} />
                <Route path="manasik" element={<JamaahManasik />} />
                <Route path="dokumen" element={<JamaahDokumen />} />
                <Route path="pembayaran" element={<JamaahPembayaran />} />
                <Route path="materi" element={<JamaahMateri />} />
                <Route path="pengumuman" element={<JamaahPengumuman />} />
                <Route path="pembimbing" element={<JamaahPembimbing />} />
              </Route>

              <Route path="/panel-pembimbing" element={<ProtectedRoute roles={["pembimbing"]}><GuideLayout /></ProtectedRoute>}>
                <Route index element={<GuideDashboard />} />
                <Route path="jamaah" element={<GuideJamaah />} />
                <Route path="manasik" element={<GuideManasik />} />
              </Route>

              <Route path="/agen" element={<ProtectedRoute roles={["agen"]}><AgentLayout /></ProtectedRoute>}>
                <Route index element={<AgentDashboard />} />
                <Route path="jamaah" element={<AgentJamaah />} />
                <Route path="komisi" element={<AgentKomisi />} />
              </Route>
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
